import { useEffect, useRef } from "react";
import { useInView } from "react-intersection-observer";
export const useIsInViewport = (props) => {
    const { shouldTrackVisibility = true, onComponentSeen, 
    // 1 = should the component be fully in viewport
    threshold = 1, triggerOnce = true, ...otherProps } = props || {};
    const { ref, inView } = useInView({
        threshold,
        triggerOnce,
        ...otherProps,
    });
    const wasComponentSeen = useRef(false);
    useEffect(() => {
        if (typeof onComponentSeen === "function" &&
            inView &&
            shouldTrackVisibility &&
            !wasComponentSeen.current) {
            wasComponentSeen.current = true;
            onComponentSeen();
        }
        else if (typeof onComponentSeen === "function" &&
            !inView &&
            shouldTrackVisibility &&
            wasComponentSeen.current &&
            !triggerOnce) {
            wasComponentSeen.current = false;
        }
    }, [
        inView,
        onComponentSeen,
        shouldTrackVisibility,
        wasComponentSeen.current,
        triggerOnce,
    ]);
    return { ref, inView };
};
